import { map, isEmpty } from "lodash";
import Base from "./_Base";
import { FormBridgeMaster as formBridgeMaster } from "@ali/gov-form-bridge";
import report from "../../utils/report";

window.formBridgeMaster = formBridgeMaster;
// eslint-disable-next-line new-cap
const bridgeMaster = new formBridgeMaster();

const PLUGIN_TYPE = {
  DEVICE: "device",
  FORM_APP: "formApp",
};

const parseDeviceData = (appId, data) => {
  // TODO 这个地方抽出来做通用的
  if (appId === "gpy") {
    const { pics, ...rest } = data;
    return {
      ...rest,
      pics: map(pics, (item) => {
        const match = item.match(/(?:.+\/)(.+)/);
        const name = match && match[1];
        return {
          url: item,
          name,
        };
      }),
    };
  }
  return data;
};

export default class Plugin extends Base {
  _type = "Plugin";

  parse = () => {
    const { plugins: dataSource } = this.schema;
    if (!dataSource || !dataSource.length) return;
    dataSource.forEach((config) => {
      const {
        pluginId,
        pluginType,
        pluginName,
        pluginButtonKey,
        appId,
        event: configEvent,
        params: configParams,
        target,
        pcUrl,
        options = {
          style: "margin: auto; width: 85%; height: 75%; margin-top: 30px;",
        },
        // type,
        // disableParamsEvent, // 禁止从 params 中解析出事件
      } = config;
      if (
        this.disableDevicePlugin !== false &&
        pluginType === PLUGIN_TYPE.DEVICE
      ) {
        // 找到关联的按钮
        this.context.onPageReady(() => {
          try {
            this.fieldApi.setFieldProp(pluginButtonKey, "visible", false);
          } catch (e) {
            console.error(e);
          }
        });
        return true;
      }
      const parsedEvent = this._parseEvent(configEvent);
      const parsedParams = this._parseParams(configParams);
      const parsedTarget = this._parseTarget(target);

      const { preHandler, handler } = parsedTarget;
      const event = parsedEvent.event;

      this._addListener({
        uuid: pluginId,
        config,
        event,
        func: (value, changedKey) => {
          const params = parsedParams.handler(config);
          if (!params) return;

          // 预处理
          // eslint-disable-next-line no-unused-expressions
          preHandler && preHandler();
          report({
            requestType: "PLUGIN_INVOKE",
            pluginName,
            pluginType,
            pluginUrl: pcUrl,
            pluginId,
          });

          if (pluginType === PLUGIN_TYPE.FORM_APP) {
            bridgeMaster.open(pcUrl, options);

            bridgeMaster.onReady(() => {
              bridgeMaster.onReceiveData((data) => {
                report(
                  {
                    requestType: "PLUGIN_DATA_COLLECT",
                    pluginName,
                    pluginType,
                    pluginUrl: pcUrl,
                    pluginId,
                  },
                  data
                );
                if (data) {
                  // 运行时构建响应数据并传入
                  return handler({
                    res: data,
                    failed: isEmpty(data),
                    changedKey,
                  });
                }

                return handler({ res: undefined, failed: true });
              });

              bridgeMaster.onClientReady(() => {
                // client ready 之后，向 client 发送数据
                bridgeMaster.postData(params);
              });
            });
          } else if (pluginType === PLUGIN_TYPE.DEVICE) {
            // 唤起SDK，并传入SDK类型 appId
            this.context.emitter.emit("callDeviceSdk", {
              visible: true,
              status: appId,
            });
            this.context.emitter.once("callDeviceSdkSuccess", (data) => {
              report(
                {
                  requestType: "PLUGIN_DATA_COLLECT",
                  pluginName,
                  pluginType,
                  pluginId,
                },
                data
              );
              // 关闭SDK弹窗
              this.context.emitter.emit("callDeviceSdk", {
                visible: false,
              });
              if (data) {
                // 如果是高拍仪，则需要转换成附件组件类型

                return handler({
                  res: parseDeviceData(appId, data),
                  failed: isEmpty(data),
                  changedKey,
                });
              }

              // 监听SDK返回内容
              return handler({ res: undefined, failed: true });
            });
          }
        },
      });
    });
  };
}
